import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { stAdjustmentsPreviewLinesFor } from "./preview-data";
import { TechnicianAdjustmentLine } from "./technician-adjustment-line";
import { TechnicianSidebarHeader } from "./technician-sidebar-header";
import type { StAdjustmentTechnicianGroup } from "./types";

export const StAdjustmentsPreviewSidebar = ({
  group,
  onClose,
}: {
  group: StAdjustmentTechnicianGroup | null;
  onClose: () => void;
}) => {
  if (!group) return null;

  const lines = stAdjustmentsPreviewLinesFor(group);

  return (
    <Stack align="start" gap={0} className="h-full w-full opacity-75">
      <TechnicianSidebarHeader group={group} onClose={onClose} />

      <Stack
        align="start"
        gap={4}
        className="min-h-0 w-full flex-1 overflow-y-auto p-5"
      >
        {lines.map((line) => (
          <TechnicianAdjustmentLine
            key={line.jobNumber}
            jobNumber={line.jobNumber}
            amountCents={line.amountCents}
            category={line.category}
            memo={line.memo}
          />
        ))}

        <Text variant="caption" tone="muted">
          Showing {lines.length} of {group.pending}
        </Text>
      </Stack>
    </Stack>
  );
};
